import React from 'react';
import { cn } from '../../lib/utils';

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  as?: React.ElementType;
}

const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(
  ({ className, as: Component = 'div', ...props }, ref) => {
    const Comp = Component;
    return (
      <Comp
        ref={ref}
        className={cn(
          "animate-pulse rounded bg-gray-200 dark:bg-gray-700",
          className
        )}
        {...props}
      />
    );
  }
);
Skeleton.displayName = "Skeleton";

export { Skeleton }; 